<script setup>
import {nextTick, onBeforeMount, reactive, ref, watch} from "vue"
import YTCard from "@/components/YTCard/YTCard.vue";
import router from "@/router/index.js";
import {addRole, detailRole, editRole, listMenuAll} from "@/api/user/user.js";
import {getRoute} from "@/hooks/getRoute.js";

const {route} = getRoute();
onBeforeMount(async () => {
  loading.value = true;
  console.log("route.query.roleId", route.query.roleId)
  if (route.query.roleId) {
    isEdit.value = true
    await handleGetDetail()
  }
  await handleGetMenuAll()
  loading.value = false
})

// 平台类型枚举
const systemTypeEnum = [
  {
    label: "运营平台（公司内部使用）",
    value: "OPERATION",
  },
  {
    label: "商家平台",
    value: "MERCHANT",
  },
]

/*编辑角色相关*/
// 是否修改
const isEdit = ref(false)
// 获取角色详情
const handleGetDetail = async () => {
  loading.value = true;
  const res = await detailRole(route.query.roleId)
  ruleForm.roleId = res.roleId
  ruleForm.roleName = res.roleName
  ruleForm.roleDesc = res.roleDesc
  ruleForm.systemType = res.systemType
  // 处理反显
  const {review: permissionArr, father: expended} = await handlePermissionsListReview(res.menuPermissionsList)
  console.log("permissionArr", permissionArr)
  cachePermission.value = new Set(permissionArr)
  checkedPermissionKeys.value = permissionArr
  defaultExpended.value = new Set(expended)
  console.log("cachePermission.value", cachePermission.value)
  loading.value = false;
}
// 处理菜单权限反显
const handlePermissionsListReview = async (list) => {
  let review = []
  let father = []
  // 一级
  list.forEach((item) => {
    // 二级
    if (item.childrenList.length > 0) {
      item.childrenList.forEach(son => {
        // 三级
        if (son.childrenList.length > 0) {
          son.childrenList.forEach(grandSon => {
            // 四级
            if (grandSon.childrenList.length > 0) {
              grandSon.childrenList.forEach(greatGrandSon => {
                if (greatGrandSon.childrenList.length > 0) {
                  // 五级
                  greatGrandSon.childrenList.forEach(greatGreatGrandSon => {
                    father.push(greatGrandSon.key)
                    review.push(greatGreatGrandSon.key)
                  })
                } else {
                  father.push(grandSon.key)
                  review.push(greatGrandSon.key)
                }
              })
            } else {
              father.push(son.key)
              review.push(grandSon.key)
            }
          })
        } else {
          father.push(item.key)
          review.push(son.key)
        }
      })
    } else {
      father.push(item.key)
      review.push(item.key)
    }
  })
  return {
    review,
    father
  }
}


/*权限菜单列表相关*/
// 菜单列表
const options = ref([])
// 勾选的菜单权限列表
const cachePermission = ref(new Set())
// 仅用于树组件初始化/反显，避免和提交权限缓存互相污染
const checkedPermissionKeys = ref([])
// 默认打开的菜单key
const defaultExpended = ref(new Set())
// 获取菜单列表
const handleGetMenuAll = async () => {
  loading.value = true
  let param = {
    systemType: ruleForm.systemType
  }
  const res = await listMenuAll(param)
  console.log("res", res)
  options.value = res
  await syncTreeCheckedKeys()
  loading.value = false
}

// 表单加载状态
const loading = ref(false);

// 表单组件锚点
const ruleFormRef = ref()

// 表单信息
const ruleForm = reactive({
  roleName: null,
  roleDesc: null,
  menuOrPermissionsList: [],
  systemType: "OPERATION"
})
// 表单校验规则
const rules = reactive({
  roleName: [
    {required: true, message: "请输入角色名称", trigger: "blur"}
  ],
  roleDesc: [
    {required: true, message: "请输入角色描述", trigger: "blur"}
  ],
  systemType: [
    {required: true, message: "请选择平台类型", trigger: "blur"}
  ]
})
// 取消新增
const cancelAdd = () => {
  router.back()
}
// 保存校验表单
const submit = async () => {
  loading.value = true
  ruleForm.menuOrPermissionsList = Array.from(cachePermission.value)
  await ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        let param = {
          ...ruleForm
        }
        if (isEdit.value) {
          await editRole(param)
        } else {
          await addRole(param)
        }
        ElMessage.success(isEdit.value ? "修改角色成功": "新增角色成功")
        router.push("/listSystemRole")
      } catch (e) {
        loading.value = false
      }
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}

// 处理平台类型改变
const handleSystemTypeChange = () => {
  handleGetMenuAll()
  cachePermission.value = new Set()
  checkedPermissionKeys.value = []
  defaultExpended.value = new Set()
}

// 树形控件属性设置
const treeProps = {
  label: "value",
  children: "childrenList",
  disabled: "disabled"
}
// 处理复选框选中节点
const handleCheck = (checkedNode, checkedObj) => {
  // 过滤非权限节点，赋值给权限数组
  console.log("checkedNode", checkedNode)
  console.log("checkedObj", checkedObj)
  let arr = [...checkedObj.checkedKeys, ...checkedObj.halfCheckedKeys]
  // 三级节点带#permission时，四级节点不可以单选，勾选一个后其余必须全选否则会出bug
  cachePermission.value = new Set(arr.filter(item => item.includes("#")))
  console.log("cachePermission", cachePermission.value)
}
// 同步树的默认勾选，仅使用接口反显数据，不使用提交缓存数据回灌组件
const syncTreeCheckedKeys = async () => {
  await nextTick()
  if (!treeRef.value) return
  treeRef.value.setCheckedKeys(checkedPermissionKeys.value)
}
// 搜索权限节点文本
const filterText = ref()
const filterNode = (value, data) => {
  if (!value) return true
  return data.value.includes(value)
}
const treeRef = ref()
// 监听变化，过滤菜单权限搜索内容
watch(filterText, (val) => {
  treeRef.value.filter(val)
})
</script>

<template>
  <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm container_form mg_b_3"
      size="large"
      v-loading="loading">
    <YTCard :title="'角色信息'" :is-show-divider="false">
      <template #container>
        <el-form-item label="角色名称" prop="roleName">
          <el-input maxlength="15" style="width: 300px" show-word-limit v-model="ruleForm.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="roleDesc">
          <el-input type="textarea" resize="none" :rows="5" maxlength="20" style="width: 300px" show-word-limit v-model="ruleForm.roleDesc" placeholder="请输入角色描述"></el-input>
        </el-form-item>
        <el-form-item label="平台类型" prop="systemType">
          <el-select v-model="ruleForm.systemType" placeholder="角色描述" style="width: 240px" @change="handleSystemTypeChange">
            <el-option
                v-for="item in systemTypeEnum"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="菜单权限">
          <div>
            <el-input
                class="mg_b_1"
                v-model="filterText"
                style="width: 240px"
                placeholder="请输入权限节点名称"
            />
            <el-tree
                ref="treeRef"
                style="max-width: 800px"
                :props="treeProps"
                show-checkbox
                :data="options"
                @check="handleCheck"
                node-key="key"
                :default-expanded-keys="Array.from(defaultExpended)"
                :filter-node-method="filterNode"
            />
          </div>
        </el-form-item>
      </template>
    </YTCard>
    <v-row class="mg_t_2">
      <v-col cols="4">
        <v-row>
          <v-col cols="6">
            <v-btn @click="cancelAdd">取消</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" @click="submit" :disabled="!$handleHasBtnPermission('any', 'systemRole:add', 'systemRole:edit')">保存</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </el-form>
</template>

<style lang="scss" scoped>
.btn_check {
  width: 28px;
  height: 28px;
  border-radius: 36px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  z-index: 100;
  background-color:#4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
}

::marker {
  content: none;
}
</style>
